import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Typography } from '../Typography';

export type FormControlLabelProps =
  import('@material-ui/core/FormControlLabel').FormControlLabelProps;

const CustomFormControlLabel: React.FC<FormControlLabelProps> = ({
  label,
  ...rest
}) => (
  <FormControlLabel
    label={<Typography.Paragraph>{label}</Typography.Paragraph>}
    {...rest}
  />
);

export { CustomFormControlLabel };
